module.exports = __webpack_public_path__ + "img/ma208.f67f19af.png";